import React from 'react';
import {useStores} from "../../../../stores/Context";
import IconeStatut from "./IconeStatut";

const IconeStatutById = ({IdStatut}) => {
    const {PlanningActionsStore} = useStores();
    const statutEnCours = PlanningActionsStore.statuts.find(statut => statut.id === IdStatut);

    return (
        <div>
            {statutEnCours && (
                <IconeStatut icone={statutEnCours.icone} couleur={statutEnCours.couleur} />
            )}
        </div>
    );
};

export default IconeStatutById;
